webpackJsonp([286],{

/***/ 1336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViolationAlertCreate_vue__ = __webpack_require__(3110);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6982e990_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViolationAlertCreate_vue__ = __webpack_require__(5860);
function injectStyle (ssrContext) {
  __webpack_require__(5858)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6982e990"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ViolationAlertCreate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6982e990_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ViolationAlertCreate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2106:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ACTION_NOTIFY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACTION_DEDUCT_POINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACTION_FORBID_ORDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_BAN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACTION_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACTION_MAP; });
/* unused harmony export STATUS_ENABLED */
/* unused harmony export STATUS_DISABLED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BAN_REASON_OPTIONS; });
/* unused harmony export DETAIL_STATUS_PENDING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DETAIL_STATUS_SENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DETAIL_STATUS_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DETAIL_STATUS_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DETAIL_STATUS_RECALLED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DETAIL_STATUS_RECALLING; });
/* unused harmony export DETAIL_STATUS_RECALL_FAILED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DETAIL_STATUS_SEARCH_OPTIONS; });
/* unused harmony export DETAIL_STATUS_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DETAIL_STATUS_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DETAIL_STATUS_TAG_TYPE; });
/* harmony export (immutable) */ __webpack_exports__["p"] = formatPunishParams;
/* harmony export (immutable) */ __webpack_exports__["u"] = formatRecallUserLabel;
/* harmony export (immutable) */ __webpack_exports__["v"] = maskCellphone;
/* harmony export (immutable) */ __webpack_exports__["q"] = formatRecallActionDetail;
/* harmony export (immutable) */ __webpack_exports__["w"] = shouldShowRecallProject;
/* harmony export (immutable) */ __webpack_exports__["s"] = formatRecallProject;
/* harmony export (immutable) */ __webpack_exports__["r"] = formatRecallMoney;
/* harmony export (immutable) */ __webpack_exports__["t"] = formatRecallSentTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _DETAIL_STATUS_TAG_TY;

var ACTION_NOTIFY = 1;
var ACTION_DEDUCT_POINT = 2;
var ACTION_FORBID_ORDER = 3;
var ACTION_BAN = 4;

var ACTION_OPTIONS = [{ label: '仅警告通知', value: ACTION_NOTIFY }, { label: '扣除零豆或赏金', value: ACTION_DEDUCT_POINT }, { label: '禁止做单', value: ACTION_FORBID_ORDER }, { label: '永久封号', value: ACTION_BAN }];

var ACTION_MAP = ACTION_OPTIONS.reduce(function (map, item) {
  map[item.value] = item.label;
  return map;
}, {});

var STATUS_ENABLED = 1;
var STATUS_DISABLED = 0;

var BAN_REASON_OPTIONS = [{ label: '多账号', value: 1 }, { label: '非本人使用', value: 2 }, { label: '虚假提交', value: 3 }, { label: '账号异常', value: 4 }, { label: '恶意抢单', value: 5 }, { label: '态度恶劣', value: 6 }, { label: '本人申请', value: 7 }, { label: '其他', value: 99 }];

var DETAIL_STATUS_PENDING = 0;
var DETAIL_STATUS_SENT = 1;
var DETAIL_STATUS_READ = 2;
var DETAIL_STATUS_FAILED = 3;
var DETAIL_STATUS_RECALLED = 4;
var DETAIL_STATUS_RECALLING = 5;
var DETAIL_STATUS_RECALL_FAILED = 6;

/** 名单搜索筛选项（不含撤回中/撤回失败） */
var DETAIL_STATUS_SEARCH_OPTIONS = [{ label: '待发送', value: DETAIL_STATUS_PENDING }, { label: '已发送', value: DETAIL_STATUS_SENT }, { label: '已读', value: DETAIL_STATUS_READ }, { label: '发送失败', value: DETAIL_STATUS_FAILED }, { label: '已撤回', value: DETAIL_STATUS_RECALLED }];

var DETAIL_STATUS_OPTIONS = [].concat(DETAIL_STATUS_SEARCH_OPTIONS, [{ label: '撤回中', value: DETAIL_STATUS_RECALLING }, { label: '撤回失败', value: DETAIL_STATUS_RECALL_FAILED }]);

var DETAIL_STATUS_MAP = DETAIL_STATUS_OPTIONS.reduce(function (map, item) {
  map[item.value] = item.label;
  return map;
}, {});

var DETAIL_STATUS_TAG_TYPE = (_DETAIL_STATUS_TAG_TY = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DETAIL_STATUS_TAG_TY, DETAIL_STATUS_PENDING, 'warning'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DETAIL_STATUS_TAG_TY, DETAIL_STATUS_SENT, ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DETAIL_STATUS_TAG_TY, DETAIL_STATUS_READ, 'success'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DETAIL_STATUS_TAG_TY, DETAIL_STATUS_FAILED, 'danger'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DETAIL_STATUS_TAG_TY, DETAIL_STATUS_RECALLED, 'info'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DETAIL_STATUS_TAG_TY, DETAIL_STATUS_RECALLING, 'warning'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DETAIL_STATUS_TAG_TY, DETAIL_STATUS_RECALL_FAILED, 'danger'), _DETAIL_STATUS_TAG_TY);

function formatPunishParams(row) {
  var action = Number(row.action);
  if (action === ACTION_DEDUCT_POINT) {
    var parts = [];
    if (Number(row.punish_point) > 0) parts.push('\u6263 ' + row.punish_point + ' \u96F6\u8C46');
    if (Number(row.punish_salary) > 0) parts.push('\u6263 ' + row.punish_salary + ' \u5143\u8D4F\u91D1');
    return parts.length ? parts.join(' + ') : '—';
  }
  if (action === ACTION_FORBID_ORDER) {
    return row.punish_day ? '\u7981\u6B62\u505A\u5355 ' + row.punish_day + ' \u5929' : '禁止做单';
  }
  if (action === ACTION_BAN) {
    var reason = BAN_REASON_OPTIONS.find(function (i) {
      return i.value === Number(row.ban_reason);
    });
    return reason ? '\u6C38\u4E45\u5C01\u53F7\uFF08' + reason.label + '\uFF09' : '永久封号';
  }
  return '仅警告通知';
}

/**
 * 撤回确认弹窗：用户展示文案
 * @param {Object} row
 * @param {Object} [options]
 * @param {boolean} [options.compact=false] 批量预览用紧凑格式（不带「用户ID」四字）
 */
function formatRecallUserLabel(row, options) {
  if (!row) return '—';
  var name = (row.user_name || '').trim();
  var uid = row.userid;
  var compact = !!(options && options.compact);
  if (name) {
    return compact ? '\u300C' + name + '\u300D\uFF08' + uid + '\uFF09' : '\u300C' + name + '\u300D\uFF08\u7528\u6237ID ' + uid + '\uFF09';
  }
  return compact ? '' + uid : '\u7528\u6237ID ' + uid;
}

/** 撤回确认弹窗：手机号脱敏 */
function maskCellphone(phone) {
  var raw = String(phone || '').trim();
  if (!raw) return '—';
  if (raw.indexOf('*') >= 0) return raw;
  if (/^1\d{10}$/.test(raw)) {
    return raw.slice(0, 3) + '****' + raw.slice(-4);
  }
  return raw;
}

/** 撤回确认弹窗：处理方式（紧凑文案，对齐原型） */
function formatRecallActionDetail(row) {
  if (!row) return '—';
  var action = Number(row.action);
  if (action === ACTION_DEDUCT_POINT) {
    var parts = [];
    if (Number(row.punish_point) > 0) parts.push('\u6263' + row.punish_point + '\u96F6\u8C46');
    if (Number(row.punish_salary) > 0) {
      parts.push('\u6263\xA5' + Number(row.punish_salary).toFixed(2) + '\u8D4F\u91D1');
    }
    return parts.length ? parts.join(' ') : '仅警告通知';
  }
  if (action === ACTION_FORBID_ORDER) {
    return row.punish_day ? '\u7981\u6B62\u505A\u5355' + row.punish_day + '\u5929' : '禁止做单';
  }
  if (action === ACTION_BAN) {
    return '永久封号';
  }
  return '仅警告通知';
}

/** 撤回确认弹窗：是否展示关联项目（扣除零豆/赏金且赏金>0，对齐原型） */
function shouldShowRecallProject(row) {
  return !!(row && Number(row.action) === ACTION_DEDUCT_POINT && Number(row.punish_salary) > 0);
}

/** 撤回确认弹窗：关联项目文案 */
function formatRecallProject(row) {
  if (!row || !Number(row.projectid)) return '—';
  var name = (row.project_name || '').trim();
  if (name) return name + ' / ' + row.projectid;
  return String(row.projectid);
}

/** 撤回确认弹窗：金额展示 */
function formatRecallMoney(amount) {
  var num = Number(amount);
  if (isNaN(num)) return '0.00';
  return num.toFixed(2);
}

/** 撤回确认弹窗：发送时间（优先展示时分秒） */
function formatRecallSentTime(sentAt) {
  var raw = String(sentAt || '').trim();
  if (!raw) return '—';
  var parts = raw.split(' ');
  if (parts.length >= 2 && /^\d{2}:\d{2}:\d{2}$/.test(parts[1])) {
    return parts[1];
  }
  return raw;
}

/***/ }),

/***/ 3110:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__ = __webpack_require__(2106);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var emptyForm = function emptyForm() {
  return {
    violation_type_id: null,
    title: '违规提醒',
    content: '',
    image: '',
    action: __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["e" /* ACTION_NOTIFY */],
    punish_point: 0,
    punish_salary: 0,
    projectid: 0,
    punish_day: 0,
    ban_reason: null,
    ban_types: [],
    select_method: 'id',
    user_list_text: '',
    ban_keyword: ''
  };
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ViolationAlertCreate',
  data: function data() {
    return {
      ACTION_DEDUCT_POINT: __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["b" /* ACTION_DEDUCT_POINT */],
      ACTION_FORBID_ORDER: __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["c" /* ACTION_FORBID_ORDER */],
      ACTION_BAN: __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["a" /* ACTION_BAN */],
      actionOptions: __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["f" /* ACTION_OPTIONS */],
      banReasonOptions: __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["g" /* BAN_REASON_OPTIONS */],
      typeOptions: [],
      form: emptyForm(),
      resolving: false,
      saving: false,
      confirmVisible: false,
      confirmUsers: [],
      rules: {
        violation_type_id: [{ required: true, message: '请选择违规类型', trigger: 'change' }],
        content: [{ required: true, message: '请填写消息内容', trigger: 'blur' }],
        action: [{ required: true, message: '请选择处理方式', trigger: 'change' }]
      }
    };
  },

  computed: {
    userListCount: function userListCount() {
      return this.parseKeywords(this.form.user_list_text).length;
    },
    missingCount: function missingCount() {
      return this.confirmUsers.filter(function (u) {
        return !u.exists;
      }).length;
    }
  },
  created: function created() {
    var _this = this;

    request.common('violationAlertTypeOptions').then(function (_ref) {
      var data = _ref.data;

      _this.typeOptions = data && data.data ? data.data : [];
    });
  },

  methods: {
    getBaiscProjectTable: function getBaiscProjectTable(params) {
      return request.page('getBaiscProjectTable', params);
    },
    getProjectDetail: function getProjectDetail(params) {
      return request.common('getProjectDetail', params);
    },
    parseKeywords: function parseKeywords(text) {
      return String(text || '').split('\n').map(function (s) {
        return s.trim();
      }).filter(Boolean);
    },
    goBack: function goBack() {
      this.$router.push({ name: '违规预警列表' });
    },
    onTypeChange: function onTypeChange(typeId) {
      var type = this.typeOptions.find(function (t) {
        return Number(t.id) === Number(typeId);
      });
      if (!type) return;
      this.form.content = type.default_content || '\u4F60\u7684\u8D26\u53F7\u56E0\u300C' + type.name + '\u300D\u884C\u4E3A\u5DF2\u88AB\u8BB0\u5F55\u8FDD\u89C4\uFF0C\u8BF7\u5C3D\u5FEB\u5728\u5BA2\u670D\u4E2D\u5FC3\u67E5\u770B\u8BE6\u60C5\u5E76\u7533\u8BC9\uFF0C\u903E\u671F\u5C06\u5F71\u54CD\u4F60\u7684\u63A5\u5355\u6743\u9650\u3002';
      this.form.image = type.default_image || '';
      this.form.action = Number(type.default_action) || __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["e" /* ACTION_NOTIFY */];
      this.form.punish_point = Number(type.default_punish_point) || 0;
      this.form.punish_salary = Number(type.default_punish_salary) || 0;
      this.form.projectid = Number(type.default_projectid) || 0;
      this.form.punish_day = Number(type.default_punish_day) || 0;
      this.form.ban_reason = type.default_ban_reason ? Number(type.default_ban_reason) : null;
      this.form.ban_types = Array.isArray(type.default_ban_types) ? type.default_ban_types.slice() : [];
      this.form.title = '违规提醒';
    },
    onChangeFile: function onChangeFile(file) {
      var _this2 = this;

      var raw = file.raw;
      var isImage = raw && (raw.type === 'image/jpeg' || raw.type === 'image/png' || raw.type === 'image/jpg');
      var isLt5M = raw && raw.size / 1024 / 1024 < 5;
      if (!isImage) {
        this.$message.error('请上传 JPG / PNG 图片');
        this.$refs.upload.clearFiles();
        return;
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB');
        this.$refs.upload.clearFiles();
        return;
      }
      var nameParts = String(raw.name || '').split('.');
      var ext = nameParts.length > 1 ? nameParts.pop().toLowerCase() : 'jpg';
      request.common('getSignedOssUrl', {
        file_name: raw.name,
        ext: ext,
        content_type: raw.type || 'image/jpeg',
        biz: 'violation_alert'
      }).then(function (_ref2) {
        var data = _ref2.data;

        return fetch(data.signedUrl, {
          method: 'PUT',
          headers: new Headers({ 'Content-Type': data.content_type }),
          body: raw
        }).then(function (uploadRes) {
          if (!uploadRes.ok) throw new Error('\u4E0A\u4F20\u5931\u8D25: ' + uploadRes.status);
          _this2.form.image = data.url;
          _this2.$message.success('上传成功');
        });
      }).catch(function (error) {
        if (error && error.message) _this2.$message.error(error.message);
      }).finally(function () {
        _this2.$refs.upload && _this2.$refs.upload.clearFiles();
      });
    },
    validateBusiness: function validateBusiness() {
      if (this.form.action === __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["b" /* ACTION_DEDUCT_POINT */]) {
        var point = Number(this.form.punish_point) || 0;
        var reward = Number(this.form.punish_salary) || 0;
        if (point <= 0 && reward <= 0) {
          this.$message.error('扣除零豆或赏金时，「扣除零豆」「扣除赏金」至少填一个（大于0）');
          return false;
        }
        if (reward > 0 && !(Number(this.form.projectid) > 0)) {
          this.$message.error('扣除赏金时必须关联一个项目');
          return false;
        }
      }
      if (this.form.action === __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["c" /* ACTION_FORBID_ORDER */] && !(Number(this.form.punish_day) > 0)) {
        this.$message.error('请填写禁止做单天数（大于0的整数）');
        return false;
      }
      if (this.form.action === __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["a" /* ACTION_BAN */] && !this.form.ban_reason) {
        this.$message.error('请选择封号原因');
        return false;
      }
      if (this.form.action === __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["a" /* ACTION_BAN */]) {
        if (!String(this.form.ban_keyword || '').trim()) {
          this.$message.error('永久封号必须选择一个用户');
          return false;
        }
      } else {
        var keywords = this.parseKeywords(this.form.user_list_text);
        if (!keywords.length) {
          this.$message.error('请填写用户列表');
          return false;
        }
        if (keywords.length > 50) {
          this.$message.error('单次违规预警最多支持 50 个用户');
          return false;
        }
      }
      return true;
    },
    onClickSend: function onClickSend() {
      var _this3 = this;

      this.$refs.form.validate(function (valid) {
        if (!valid) return;
        if (!_this3.validateBusiness()) return;

        var method = _this3.form.select_method;
        var keywords = _this3.parseKeywords(_this3.form.user_list_text);
        if (_this3.form.action === __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["a" /* ACTION_BAN */]) {
          var kw = String(_this3.form.ban_keyword || '').trim();
          keywords = [kw];
          method = /^1\d{10}$/.test(kw) ? 'phone' : 'id';
        }

        _this3.resolving = true;
        request.common('violationAlertRecordResolveUsers', { method: method, keywords: keywords }).then(function (_ref3) {
          var data = _ref3.data;

          _this3.confirmUsers = data && data.data ? data.data : [];
          _this3.confirmVisible = true;
        }).finally(function () {
          _this3.resolving = false;
        });
      });
    },
    buildPayload: function buildPayload() {
      var payload = {
        violation_type_id: Number(this.form.violation_type_id),
        title: '违规提醒',
        content: (this.form.content || '').trim(),
        image: this.form.image || '',
        action: Number(this.form.action),
        punish_point: 0,
        punish_salary: 0,
        projectid: 0,
        punish_day: 0,
        ban_reason: 0,
        ban_types: [],
        userids: this.confirmUsers.filter(function (u) {
          return u.exists;
        }).map(function (u) {
          return Number(u.userid);
        })
      };
      if (payload.action === __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["b" /* ACTION_DEDUCT_POINT */]) {
        payload.punish_point = Number(this.form.punish_point) || 0;
        payload.punish_salary = Number(this.form.punish_salary) || 0;
        payload.projectid = payload.punish_salary > 0 ? Number(this.form.projectid) || 0 : 0;
      } else if (payload.action === __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["c" /* ACTION_FORBID_ORDER */]) {
        payload.punish_day = Number(this.form.punish_day) || 0;
      } else if (payload.action === __WEBPACK_IMPORTED_MODULE_0__violation_alert_constants__["a" /* ACTION_BAN */]) {
        payload.ban_reason = Number(this.form.ban_reason) || 0;
        payload.ban_types = (this.form.ban_types || []).slice();
      }
      return payload;
    },
    onConfirmSend: function onConfirmSend() {
      var _this4 = this;

      if (this.missingCount > 0) return;
      this.saving = true;
      request.common('violationAlertRecordCreate', this.buildPayload()).then(function () {
        _this4.$message.success('已保存违规预警消息（未真正执行处罚/推送）');
        _this4.confirmVisible = false;
        _this4.goBack();
      }).finally(function () {
        _this4.saving = false;
      });
    }
  }
});

/***/ }),

/***/ 5858:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5859);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("3c8a0395", content, true, {});

/***/ }),

/***/ 5859:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".create-form[data-v-6982e990]{max-width:720px}.section-title[data-v-6982e990]{font-size:14px;font-weight:600;color:#303133;margin:8px 0 16px;padding-top:8px;border-top:1px solid #ebeef5}.section-title[data-v-6982e990]:first-child{border-top:0;padding-top:0;margin-top:0}.field-tip[data-v-6982e990],.upload-tip[data-v-6982e990]{color:#909399;font-size:12px;line-height:1.6;margin:4px 0 12px 120px}.el-form-item .field-tip[data-v-6982e990]{margin:6px 0 0}.blacklist-tips[data-v-6982e990]{color:#909399;font-size:12px;line-height:1.8;margin-top:8px}.danger-text[data-v-6982e990]{color:#f56c6c}.confirm-desc[data-v-6982e990]{margin-bottom:12px;color:#606266;font-size:13px}.confirm-warn[data-v-6982e990]{margin-top:8px;color:#f56c6c;font-size:12px}.avatar-uploader .el-upload[data-v-6982e990]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden}.avatar-uploader-icon[data-v-6982e990]{font-size:28px;color:#8c939d;width:96px;height:96px;line-height:96px;text-align:center}.avatar[data-v-6982e990]{width:96px;height:96px;display:block;-o-object-fit:cover;object-fit:cover}", "", {"version":3,"sources":["/workspace/src/views/violation-alert/pages/ViolationAlertCreate.vue"],"names":[],"mappings":"AACA,8BAA8B,eAAe,CAC5C,AACD,gCAAgC,eAAe,gBAAgB,cAAc,kBAAkB,gBAAgB,4BAA4B,CAC1I,AACD,4CAA4C,aAAa,cAAc,YAAY,CAClF,AACD,yDAAyD,cAAc,eAAe,gBAAgB,uBAAuB,CAC5H,AACD,0CAA0C,cAAc,CACvD,AACD,iCAAiC,cAAc,eAAe,gBAAgB,cAAc,CAC3F,AACD,8BAA8B,aAAa,CAC1C,AACD,+BAA+B,mBAAmB,cAAc,cAAc,CAC7E,AACD,+BAA+B,eAAe,cAAc,cAAc,CACzE,AACD,6CAA6C,0BAA0B,kBAAkB,eAAe,kBAAkB,eAAe,CACxI,AACD,uCAAuC,eAAe,cAAc,WAAW,YAAY,iBAAiB,iBAAiB,CAC5H,AACD,yBAAyB,WAAW,YAAY,cAAc,oBAAoB,gBAAgB,CACjG","file":"ViolationAlertCreate.vue","sourcesContent":["\n.create-form[data-v-6982e990]{max-width:720px\n}\n.section-title[data-v-6982e990]{font-size:14px;font-weight:600;color:#303133;margin:8px 0 16px;padding-top:8px;border-top:1px solid #ebeef5\n}\n.section-title[data-v-6982e990]:first-child{border-top:0;padding-top:0;margin-top:0\n}\n.upload-tip[data-v-6982e990],.field-tip[data-v-6982e990]{color:#909399;font-size:12px;line-height:1.6;margin:4px 0 12px 120px\n}\n.el-form-item .field-tip[data-v-6982e990]{margin:6px 0 0\n}\n.blacklist-tips[data-v-6982e990]{color:#909399;font-size:12px;line-height:1.8;margin-top:8px\n}\n.danger-text[data-v-6982e990]{color:#f56c6c\n}\n.confirm-desc[data-v-6982e990]{margin-bottom:12px;color:#606266;font-size:13px\n}\n.confirm-warn[data-v-6982e990]{margin-top:8px;color:#f56c6c;font-size:12px\n}\n.avatar-uploader .el-upload[data-v-6982e990]{border:1px dashed #d9d9d9;border-radius:6px;cursor:pointer;position:relative;overflow:hidden\n}\n.avatar-uploader-icon[data-v-6982e990]{font-size:28px;color:#8c939d;width:96px;height:96px;line-height:96px;text-align:center\n}\n.avatar[data-v-6982e990]{width:96px;height:96px;display:block;-o-object-fit:cover;object-fit:cover\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 5860:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":{ path: '/' }}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":{ name: '违规预警列表' }}},[_vm._v("违规预警")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('template',{slot:"header"},[_vm._v("添加违规预警消息")]),_vm._v(" "),_c('template',{slot:"tools"},[_c('router-link',{attrs:{"to":{name: '违规预警列表'}}},[_c('el-button',{attrs:{"size":"small","icon":"el-icon-back"}},[_vm._v("返回列表")])],1)],1),_vm._v(" "),_c('el-form',{ref:"form",staticClass:"create-form",attrs:{"model":_vm.form,"rules":_vm.rules,"label-width":"120px","size":"medium"}},[_c('div',{staticClass:"section-title"},[_vm._v("通知内容")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"违规类型","prop":"violation_type_id"}},[_c('el-select',{staticClass:"width-max",attrs:{"filterable":"","placeholder":"请选择违规类型"},on:{"change":_vm.onTypeChange},model:{value:(_vm.form.violation_type_id),callback:function ($$v) {_vm.$set(_vm.form, "violation_type_id", $$v)},expression:"form.violation_type_id"}},_vm._l((_vm.typeOptions),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":Number(item.id)}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"消息内容","prop":"content"}},[_c('el-input',{attrs:{"type":"textarea","rows":4,"maxlength":"300","placeholder":"请输入消息内容，限300字"},model:{value:(_vm.form.content),callback:function ($$v) {_vm.$set(_vm.form, "content", $$v)},expression:"form.content"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"图片","prop":"image"}},[_c('el-upload',{ref:"upload",staticClass:"avatar-uploader",attrs:{"auto-upload":false,"action":"","accept":"image/png,image/jpeg","show-file-list":false,"on-change":_vm.onChangeFile}},[(_vm.form.image)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.form.image}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})]),_vm._v(" "),(_vm.form.image)?_c('el-button',{staticClass:"danger-text",attrs:{"type":"text"},on:{"click":function($event){_vm.form.image = ''}}},[_vm._v("移除图片")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"upload-tip"},[_vm._v("非必填，最多 1 张；JPG/PNG，≤5MB")])],1),_vm._v(" "),_c('div',{staticClass:"section-title"},[_vm._v("处理结果")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"处理方式","prop":"action"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择处理方式"},model:{value:(_vm.form.action),callback:function ($$v) {_vm.$set(_vm.form, "action", $$v)},expression:"form.action"}},_vm._l((_vm.actionOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),(_vm.form.action === _vm.ACTION_DEDUCT_POINT)?[_c('el-form-item',{attrs:{"label":"扣除零豆"}},[_c('el-input',{attrs:{"type":"number","min":"0"},model:{value:(_vm.form.punish_point),callback:function ($$v) {_vm.$set(_vm.form, "punish_point", _vm._n($$v))},expression:"form.punish_point"}},[_c('template',{slot:"append"},[_vm._v("个")])],2)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"扣除赏金"}},[_c('el-input',{attrs:{"type":"number","min":"0","step":"0.01"},model:{value:(_vm.form.punish_salary),callback:function ($$v) {_vm.$set(_vm.form, "punish_salary", _vm._n($$v))},expression:"form.punish_salary"}},[_c('template',{slot:"append"},[_vm._v("元")])],2)],1),_vm._v(" "),_c('div',{staticClass:"field-tip"},[_vm._v("两个字段至少填一个，均为大于 0 才生效；扣除赏金 > 0 时必须关联项目")]),_vm._v(" "),(Number(_vm.form.punish_salary) > 0)?_c('el-form-item',{attrs:{"label":"项目名称","prop":"projectid","required":true}},[_c('remote-select',{attrs:{"id-key":"number","label-key":"name","value-key":"id","placeholder":"请输入项目名称/编号搜索","query-request":_vm.getBaiscProjectTable,"find-request":_vm.getProjectDetail,"clearable":""},model:{value:(_vm.form.projectid),callback:function ($$v) {_vm.$set(_vm.form, "projectid", $$v)},expression:"form.projectid"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.form.action === _vm.ACTION_FORBID_ORDER)?[_c('el-form-item',{attrs:{"label":"禁止天数","prop":"punish_day"}},[_c('el-input',{attrs:{"type":"number","min":"1"},model:{value:(_vm.form.punish_day),callback:function ($$v) {_vm.$set(_vm.form, "punish_day", _vm._n($$v))},expression:"form.punish_day"}},[_c('template',{slot:"append"},[_vm._v("天")])],2)],1)]:_vm._e(),_vm._v(" "),(_vm.form.action === _vm.ACTION_BAN)?[_c('el-form-item',{attrs:{"label":"封号原因","prop":"ban_reason"}},[_c('el-select',{staticClass:"width-max",attrs:{"placeholder":"请选择封号原因","clearable":""},model:{value:(_vm.form.ban_reason),callback:function ($$v) {_vm.$set(_vm.form, "ban_reason", $$v)},expression:"form.ban_reason"}},_vm._l((_vm.banReasonOptions),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"添加黑名单池"}},[_c('el-checkbox-group',{model:{value:(_vm.form.ban_types),callback:function ($$v) {_vm.$set(_vm.form, "ban_types", $$v)},expression:"form.ban_types"}},[_c('el-checkbox',{attrs:{"label":"idcard"}},[_vm._v("身份证（永久）")]),_vm._v(" "),_c('el-checkbox',{attrs:{"label":"phone"}},[_vm._v("手机号（永久）")])],1),_vm._v(" "),_c('div',{staticClass:"blacklist-tips"},[_c('div',[_vm._v("*释：身份证加入黑名单池后，下次用户换号实名该身份证，提示你的身份已冻结")]),_vm._v(" "),_c('div',[_vm._v("手机号加入黑名单池，下次用户用此手机号将无法登录，提示该账号已冻结")])])],1)]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"section-title"},[_vm._v("发送对象")]),_vm._v(" "),(_vm.form.action === _vm.ACTION_BAN)?[_c('el-form-item',{attrs:{"label":"封号用户","prop":"ban_keyword","required":""}},[_c('el-input',{attrs:{"placeholder":"输入用户ID或手机号","clearable":""},model:{value:(_vm.form.ban_keyword),callback:function ($$v) {_vm.$set(_vm.form, "ban_keyword", $$v)},expression:"form.ban_keyword"}}),_vm._v(" "),_c('div',{staticClass:"field-tip"},[_vm._v("永久封号仅支持单用户操作")])],1)]:[_c('el-form-item',{attrs:{"label":"用户选择方式","prop":"select_method"}},[_c('el-radio-group',{model:{value:(_vm.form.select_method),callback:function ($$v) {_vm.$set(_vm.form, "select_method", $$v)},expression:"form.select_method"}},[_c('el-radio',{attrs:{"label":"id"}},[_vm._v("用户ID")]),_vm._v(" "),_c('el-radio',{attrs:{"label":"phone"}},[_vm._v("手机号")])],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"用户列表","prop":"user_list_text"}},[_c('el-input',{attrs:{"type":"textarea","rows":5,"placeholder":_vm.form.select_method === 'phone' ? '每行一个手机号' : '每行一个用户ID'},model:{value:(_vm.form.user_list_text),callback:function ($$v) {_vm.$set(_vm.form, "user_list_text", $$v)},expression:"form.user_list_text"}}),_vm._v(" "),_c('div',{staticClass:"field-tip"},[_vm._v("\n            已输入 "+_vm._s(_vm.userListCount)+" / 50 个用户\n            "),(_vm.userListCount > 50)?_c('span',{staticClass:"danger-text"},[_vm._v("（已超出上限，请精简到 50 个以内）")]):_vm._e()])],1)],_vm._v(" "),_c('el-form-item',[_c('el-button',{on:{"click":_vm.goBack}},[_vm._v("取消")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.resolving},on:{"click":_vm.onClickSend}},[_vm._v("发送")])],1)],2)],2),_vm._v(" "),_c('el-dialog',{attrs:{"title":"确认发送对象","visible":_vm.confirmVisible,"width":"720px","close-on-click-modal":false},on:{"update:visible":function($event){_vm.confirmVisible=$event}}},[_c('div',{staticClass:"confirm-desc"},[_vm._v("\n      将向以下 "),_c('strong',[_vm._v(_vm._s(_vm.confirmUsers.length))]),_vm._v(" 名用户发送违规预警（本阶段仅保存记录，不真正执行处罚/推送）\n    ")]),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.confirmUsers,"border":"","size":"small","max-height":"360"}},[_c('el-table-column',{attrs:{"type":"index","label":"#","width":"50"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"userid","label":"用户ID","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"cellphone","label":"手机号","width":"130"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"姓名","min-width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"region","label":"所在地区","min-width":"160"}})],1),_vm._v(" "),(_vm.missingCount > 0)?_c('div',{staticClass:"confirm-warn"},[_vm._v("有 "+_vm._s(_vm.missingCount)+" 个用户未匹配，请返回修改")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.confirmVisible = false}}},[_vm._v("返回修改")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary","loading":_vm.saving,"disabled":_vm.missingCount > 0 || !_vm.confirmUsers.length},on:{"click":_vm.onConfirmSend}},[_vm._v("确认发送")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/ViolationAlertCreate.6fd9339efd15d61a366d.js